import script from "./MModalSeletorRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./MModalSeletorRadio.vue?vue&type=script&setup=true&lang=ts"

import "./MModalSeletorRadio.vue?vue&type=style&index=0&id=29c6dc9a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29c6dc9a"]])

export default __exports__